import { useState } from "react";
import LayoutActividad from "../../../components/LayoutActividad";
import Imagen1 from "../../../images/modulo1/familiaela.png";
import Imagen2 from "../../../images/modulo1/familiajailer.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { faEye } from "@fortawesome/free-solid-svg-icons";
import { modulo1 } from "../../../routes/Module1";
import Sidebar from "../Sidebar";
import GuiaDocente from "../../../components/GuiaDocente";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo1/Actividad2.mp3";

const Actividad2 = () => {
  const [answers, setAnswers] = useState({
    pregunta1: null,
    pregunta2: null,
    pregunta3: null,
    pregunta4: null,
  });
  const [answersStatus, setAnswersStatus] = useState({
    pregunta1: 0,
    pregunta2: 0,
    pregunta3: 0,
    pregunta4: 0,
  });

  const infoUnidad = modulo1.content[0];
  const infoAct = modulo1.content[0].activities[1];
  const crumbs = [
    {
      title: modulo1.title,
      url: "/" + modulo1.url,
    },
    {
      title:
        modulo1.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];
  const pages = {
    titleNext: `${modulo1.content[0].activities[2].name}`,
    linkNext: `${modulo1.url}/${modulo1.content[0].path}/${modulo1.content[0].activities[2].path}`,
    titlePrev: `${modulo1.content[0].activities[0].name}`,
    linkPrev: `${modulo1.url}/${modulo1.content[0].path}/${modulo1.content[0].activities[0].path}`,
  };
  const metadata = {
    color: modulo1.color,
    title: `${modulo1.title} - ${infoAct.name}`,
    name: modulo1.title
  };
  const onChangeValue1 = (event) => {
    setAnswers({ ...answers, pregunta1: event.target.value });
  };
  const onChangeValue2 = (event) => {
    setAnswers({ ...answers, pregunta2: event.target.value });
  };
  const onChangeValue3 = (event) => {
    setAnswers({ ...answers, pregunta1: event.target.value });
  };
  const onChangeValue4 = (event) => {
    setAnswers({ ...answers, pregunta2: event.target.value });
  };
  const validateColumn1 = (e) => {
    e.preventDefault();

    // Pregunta 1
    let pregunta1 = answers.pregunta1 === "6" ? 2 : 1;
    let pregunta2 = answers.pregunta2 === "2" ? 2 : 1;

    setAnswersStatus({ ...answersStatus, pregunta1, pregunta2 });
  };
  const validateColumn2 = (e) => {
    e.preventDefault();

    // Pregunta 1
    let pregunta1 = answers.pregunta1 === "6" ? 2 : 1;
    let pregunta2 = answers.pregunta2 === "2" ? 2 : 1;

    setAnswersStatus({ ...answersStatus, pregunta1, pregunta2 });
  };
  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo1.color} hat-text`}>
          <FontAwesomeIcon icon={faEye} /> Observamos
        </small>
      </p>

      <h2 className="mb-5">Actividad 2</h2>
      <AudioPlayer track={Audio} />
      <div className="row">
        <div className="col-md-10 col-sm-12 mb-5">
          <ul>
            <li>También las familias son todas diferentes.</li>
            <li>Observa a estas dos familias y responde las preguntas.</li>
          </ul>
        </div>
      </div>
      <div className="row">
        <div className="col-md-6 col-sm-12">
          <img src={Imagen1} className="img-fluid mb-3" alt="Familia" />
          <p>
            <strong>1. Selecciona tus respuestas</strong>
          </p>
          <p>¿Cuántas personas componen esta familia?</p>
          <div className="d-flex" onChange={onChangeValue1}>
            <div className="pe-4">
              <input
                type="radio"
                name="pregunta1"
                value="2"
                className="form-check-input"
              />{" "}
              <label htmlFor="pregunta1">2</label>
            </div>
            <div className="pe-4">
              <input
                type="radio"
                name="pregunta1"
                value="4"
                className="form-check-input"
              />{" "}
              <label htmlFor="pregunta1">4</label>
            </div>
            <div className="pe-4">
              <input
                type="radio"
                name="pregunta1"
                value="3"
                className="form-check-input"
              />{" "}
              <label htmlFor="pregunta1">3</label>
            </div>
            <div className="pe-4">
              <input
                type="radio"
                name="pregunta1"
                value="6"
                className="form-check-input"
              />{" "}
              <label htmlFor="pregunta1">6</label>
            </div>
          </div>

          {answersStatus.pregunta1 === 2 ? (
            <div className="alert alert-success mt-2" role="alert">
              Respuesta correcta
            </div>
          ) : null}
          {answersStatus.pregunta1 === 1 ? (
            <div className="alert alert-danger mt-2" role="alert">
              Respuesta incorrecta
            </div>
          ) : null}

          <p className="mt-4">¿Cuántas niñas hay?</p>
          <div className="d-flex" onChange={onChangeValue2}>
            <div className="pe-4">
              <input
                type="radio"
                name="pregunta2"
                value="2"
                className="form-check-input"
              />{" "}
              <label htmlFor="pregunta2">2</label>
            </div>
            <div className="pe-4">
              <input
                type="radio"
                name="pregunta2"
                value="1"
                className="form-check-input"
              />{" "}
              <label htmlFor="pregunta2">1</label>
            </div>
            <div className="pe-4">
              <input
                type="radio"
                name="pregunta2"
                value="3"
                className="form-check-input"
              />{" "}
              <label htmlFor="pregunta2">3</label>
            </div>
            <div className="pe-4">
              <input
                type="radio"
                name="pregunta2"
                value="5"
                className="form-check-input"
              />{" "}
              <label htmlFor="pregunta2">5</label>
            </div>
          </div>
          {answersStatus.pregunta2 === 2 ? (
            <div className="alert alert-success mt-2" role="alert">
              Respuesta correcta
            </div>
          ) : null}
          {answersStatus.pregunta2 === 1 ? (
            <div className="alert alert-danger mt-2" role="alert">
              Respuesta incorrecta
            </div>
          ) : null}
          <p className="mt-4">
            <strong>2. Escribe tus respuestas:</strong>
          </p>
          <p>¿Quiénes son los adultos que cuidan al resto de la familia?</p>
          <textarea rows="5" className="form-control" />
          <div className="d-flex w-100 justify-content-start my-4">
            <button
              className={`btn btn-${modulo1.color}`}
              onClick={validateColumn1}
            >
              Enviar respuestas
            </button>
          </div>
        </div>

        <div className="col-md-6 col-sm-12">
          <img src={Imagen2} className="img-fluid mb-3" alt="Familia" />
          <p>
            <strong>1. Selecciona tus respuestas</strong>
          </p>
          <p>¿Cuántas personas componen esta familia?</p>
          <div className="d-flex" onChange={onChangeValue3}>
            <div className="pe-4">
              <input
                type="radio"
                name="pregunta3"
                value="2"
                className="form-check-input"
              />{" "}
              <label htmlFor="pregunta3">2</label>
            </div>
            <div className="pe-4">
              <input
                type="radio"
                name="pregunta3"
                value="4"
                className="form-check-input"
              />{" "}
              <label htmlFor="pregunta3">4</label>
            </div>
            <div className="pe-4">
              <input
                type="radio"
                name="pregunta3"
                value="3"
                className="form-check-input"
              />{" "}
              <label htmlFor="pregunta3">3</label>
            </div>
            <div className="pe-4">
              <input
                type="radio"
                name="pregunta3"
                value="5"
                className="form-check-input"
              />{" "}
              <label htmlFor="pregunta3">5</label>
            </div>
          </div>

          {answersStatus.pregunta3 === 2 ? (
            <div className="alert alert-success mt-2" role="alert">
              Respuesta correcta
            </div>
          ) : null}
          {answersStatus.pregunta3 === 1 ? (
            <div className="alert alert-danger mt-2" role="alert">
              Respuesta incorrecta
            </div>
          ) : null}

          <p className="mt-4">¿Cuántas niñas hay?</p>
          <div className="d-flex" onChange={onChangeValue4}>
            <div className="pe-4">
              <input
                type="radio"
                name="pregunta4"
                value="2"
                className="form-check-input"
              />{" "}
              <label htmlFor="pregunta4">2</label>
            </div>
            <div className="pe-4">
              <input
                type="radio"
                name="pregunta4"
                value="1"
                className="form-check-input"
              />{" "}
              <label htmlFor="pregunta4">1</label>
            </div>
            <div className="pe-4">
              <input
                type="radio"
                name="pregunta4"
                value="0"
                className="form-check-input"
              />{" "}
              <label htmlFor="pregunta4">0</label>
            </div>
            <div className="pe-4">
              <input
                type="radio"
                name="pregunta4"
                value="5"
                className="form-check-input"
              />{" "}
              <label htmlFor="pregunta4">5</label>
            </div>
          </div>
          {answersStatus.pregunta4 === 2 ? (
            <div className="alert alert-success mt-2" role="alert">
              Respuesta correcta
            </div>
          ) : null}
          {answersStatus.pregunta4 === 1 ? (
            <div className="alert alert-danger mt-2" role="alert">
              Respuesta incorrecta
            </div>
          ) : null}
          <p className="mt-4">
            <strong>2. Escribe tus respuestas:</strong>
          </p>
          <p>¿Quiénes son los adultos que cuidan al resto de la familia?</p>
          <textarea rows="5" className="form-control" />
          <div className="d-flex w-100 justify-content-start mt-4">
            <button
              className={`btn btn-${modulo1.color}`}
              onClick={validateColumn2}
            >
              Enviar respuestas
            </button>
          </div>
        </div>
      </div>

      <GuiaDocente>
        <p>
          Lea las indicaciones. Observen las imágenes. Lea las preguntas y
          escuche atentamente las respuestas. Para finalizar, destaque que puede
          haber muchos hijos o pocos, puede haber papá y mamá o solo uno de
          ellos, también podría haber un abuelo, etc.
        </p>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad2;
